'use client'

import React, {useEffect, useState} from 'react'
import classNames from 'classnames'
import {Navigation} from 'swiper/modules'
import {Swiper, SwiperClass, SwiperSlide} from 'swiper/react'

import 'swiper/css'

import {LinkButton} from '../../../ui/components'
import {Button} from '../../../ui/components'
import {TNavigation} from '../../types'

import styles from './styles.module.css'
import './swiper.css'

type TAnchorLinksProps = {navigation: TNavigation[]; currentLink?: string}

export function AnchorLinks({navigation, currentLink}: TAnchorLinksProps) {
  const [isStartSliding, setIsStartSliding] = useState(true)
  const [isEndSliding, setIsEndSliding] = useState(false)
  const [swiper, setSwiper] = useState<SwiperClass | null>(null)

  useEffect(() => {
    if (swiper && currentLink) {
      const slideIndex = navigation.findIndex(({link}) => link === currentLink)

      if (slideIndex >= 0) {
        swiper.slideTo(slideIndex)
      }
    }
  }, [currentLink, navigation, swiper])

  if (navigation.length === 0) {
    return null
  }

  const handleSlideChange = (e: SwiperClass) => {
    const {isBeginning, isEnd} = e

    setIsStartSliding(isBeginning)
    setIsEndSliding(isEnd)
  }

  return (
    <nav className={styles.anchorLinks}>
      <Button
        className={classNames('link-prev-button', styles.navigationButton, styles.prevButton)}
        variant="navigation"
        icon="chevron"
        size="s"
      />

      {swiper?.allowSlidePrev && !isStartSliding && <span className={styles.linksBefore}></span>}

      <Swiper
        onSwiper={setSwiper}
        direction="horizontal"
        onSlideChange={handleSlideChange}
        slidesPerView="auto"
        className={styles.linksContainer}
        navigation={{
          prevEl: '.link-prev-button',
          nextEl: '.link-next-button',
        }}
        modules={[Navigation]}
      >
        {navigation.map(({label, link}) => (
          <SwiperSlide key={link} className={styles.slide}>
            <LinkButton href={link} shape="rounded" size="m" variant="secondary">
              {label}
            </LinkButton>
          </SwiperSlide>
        ))}
      </Swiper>

      {swiper?.allowSlideNext && !isEndSliding && <span className={styles.linksAfter}></span>}

      <Button
        className={classNames(styles.nextButton, styles.navigationButton, 'link-next-button')}
        variant="navigation"
        icon="chevron"
        size="s"
      />
    </nav>
  )
}
